import React from 'react';
import { TouchableOpacity, StyleSheet, Text } from 'react-native';
import { MainColors } from '../../constants/Colors';

const LinkStyleButton = (props) => {

    return (
        <TouchableOpacity
            style={styles.buttonContainer}
            onPress={!props.disabled && props.onPress}
            accessibilityLabel={props.accessibilityLabel}
            accessibilityRole={"link"}
            disabled={props.disabled}
            >
            <Text
                style={[styles.buttonText, props.style]}
                accessibilityHint={props.accessibilityHint}>
                {props.buttonText}
            </Text>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    buttonContainer: {
        justifyContent: 'center',
        alignSelf: 'center'
    },
    buttonText: {
        color: MainColors.primary,
    }
});

export default LinkStyleButton;